module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reports"
  }, [_c('el-row', [_c('div', {
    staticClass: "panelheader"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.pageName) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select some fields",
      "multiple": "",
      "collapse-tags": ""
    },
    model: {
      value: (_vm.displayFields),
      callback: function($$v) {
        _vm.displayFields = $$v
      },
      expression: "displayFields"
    }
  }, _vm._l((_vm.sites), function(site) {
    return _c('el-option-group', {
      key: site.id,
      attrs: {
        "label": site.name
      }
    }, _vm._l((site.fields), function(field) {
      return _c('el-option', {
        key: field.id,
        attrs: {
          "value": field.id,
          "label": field.field_name
        }
      })
    }))
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select club(s)",
      "multiple": "",
      "collapse-tags": ""
    },
    model: {
      value: (_vm.displayClubs),
      callback: function($$v) {
        _vm.displayClubs = $$v
      },
      expression: "displayClubs"
    }
  }, _vm._l((_vm.clubs), function(club) {
    return _c('el-option', {
      key: club.id,
      attrs: {
        "value": club.name,
        "label": club.name
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "To",
      "start-placeholder": "Start date",
      "end-placeholder": "End date",
      "unlink-panels": "",
      "picker-options": _vm.datePickerOptions
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('fields-time', {
    attrs: {
      "displayFields": _vm.displayFields,
      "dateRange": _vm.formatDR
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('user-actions', {
    attrs: {
      "displayFields": _vm.displayFields,
      "dateRange": _vm.formatDR
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('lights-table', {
    attrs: {
      "displayFields": _vm.displayFields,
      "dateRange": _vm.formatDR
    }
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78525e2d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports.vue
// module id = 960
// module chunks = 6